import React from 'react';
import PropTypes from 'prop-types';
import Confirm from 'components/Confirm';
import Message from 'components/Message';
import appMessages from 'features/App/App.messages';
import { confirmPublishModalMessages as messages } from '../../ClasstivitySchedulerForm.messages';

export const ConfirmPublishModal = ({ schedulesCount }) => (
  <Confirm
    title={<Message message={messages.title} />}
    cancelNode={<Message message={appMessages.cancel} />}
    acceptNode={<Message message={messages.accept} />}
    isOpen>
    <Message message={messages.body} values={{ schedulesCount }} />
  </Confirm>
);

ConfirmPublishModal.propTypes = {
  schedulesCount: PropTypes.number,
};
